<div class="{{localService.selectedLanguageCode}}"
  *ngIf="elementIds && localService.languageContent && localService.languageContent.barcode">
  <div class="row" *ngIf="title != ''">
    <div class="col-12" style="text-align:center;">
      <label (click)="onTitleClick()" class="button">{{title}}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-6" id="{{elementIds.qr_code_container}}">
      <qrcode [qrdata]="barcodeValue" [width]="200" [errorCorrectionLevel]="'H'"></qrcode>
      <div *ngIf="displayValue != ''" class="display_val">
        {{displayValue}}
      </div>
      <app-print *ngIf="IsPrint" [printWidth]="printWidth" [fileName]="FileName" [content]="printContent"
        (onPrinted)="onPrintedBarcode()">
      </app-print>
    </div>
    <div class="col-6">
      <div class="row">
        <div style="font-weight:bold" *ngIf="!localService.isHideDummy && categoryCode != 0 && value != '0'">
          {{localService.languageContent.barcode.code}}
        </div>
        <div *ngIf="!localService.isHideDummy && categoryCode != 0 && value != '0'">
          <span class="en">{{value}}</span>
        </div>
        <div *ngIf="isPopup && isQuantityShow">
          <div style="font-weight:bold">
            {{localService.languageContent.barcode.product_qty}}
          </div>
          <div>
            <input autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event)"
              [(ngModel)]="quantity" [ngClass]="quantity != null ? 'en' : ''"
              placeholder="{{localService.languageContent.barcode.product_qty}}"
              title="{{localService.languageContent.barcode.product_qty}}" (keyup)="onChange(1)"
              (keydown)="localService.onNumEnterEvent($event,10)" id="{{elementIds.qr_code_quantity}}" />
          </div>
          <div>
            <label style="margin-left:10px;font-weight:normal;">
              <input type="checkbox" [(ngModel)]="isNoQuantity" (change)="onChange(2)">
              <span style="color:darkslategrey">&nbsp;{{localService.languageContent.barcode.no_quantity}}</span>
            </label>
          </div>
        </div>
        <div [ngStyle]="{'display' : isPopup ? 'none' : 'inline-block'}" style="margin-top:10px;">
          <button style="width:100%;" type="button" class="btn btn-primary" [id]="elementIds.qr_code_save"
            (click)="onSave()">{{localService.languageContent.common.save}}</button>
          &nbsp;
          <div class="row" *ngIf="!localService.isHideDummy">
            <div class="col-12">
              <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSize ? 'en' : ''"
                style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                [(ngModel)]="barCodeSize" placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
                title="*{{localService.languageContent.barcode.bar_code_size}}" (blur)="onSaveLastUsedSettings()" />
            </div>
          </div>
          <button style="width:100%;" type="button" class="btn btn-primary" [id]="elementIds.qr_code_print"
            (click)="onSave(true)">{{localService.languageContent.barcode.print}}</button>
          &nbsp;
          <button style="width:100%;" type="button" class="btn btn-primary" *ngIf="isBusiness && isShowLabelPrint"
            (click)="onAction(1)">{{isShowMore ? localService.languageContent.barcode.hide_label_print :
            localService.languageContent.barcode.show_label_print}}</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isProduct && isShowLabelPrint">
    <div class="row">
      <div>
        <label>{{localService.languageContent.barcode.label}}</label>
      </div>
      <table style="width: calc(100% - 10px);" class="box">
        <tr>
          <td style="width: 25%;">
            <div style="margin-bottom: -20px;">
              <qrcode [qrdata]="barcodeValue" [width]="100" [errorCorrectionLevel]="'H'"></qrcode>
              <div *ngIf="displayValue != ''">
                {{displayValue}}
              </div>
            </div>
            <div class="en" style="text-align: center;font-size:1.25em !important;">
              {{productPrice | number: '1.2-2'}}
            </div>
          </td>
          <td style="width: 75%;">
            <div [ngClass]="item.key" *ngFor="let item of titles" style="margin-bottom: 10px;">
              <span style="font-size:30px;">{{item.value}}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row">
      <div class="12">
        <div style="text-align: right;">
          <span>{{localService.languageContent.barcode.select_language}}</span>
        </div>
        <div *ngIf="languages">
          <ngx-select [items]="languages" [optionValueField]="'key'" [optionTextField]="'value'" [multiple]="true"
            placeholder="{{localService.languageContent.barcode.select_language}}" [(ngModel)]="selectedLanguages"
            [noAutoComplete]="true" (select)="onSelectLanguage()" (remove)="onSelectLanguage()">
          </ngx-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.bar_code_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSizeProduct ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="barCodeSizeProduct" placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
          title="*{{localService.languageContent.barcode.bar_code_size}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.total_width}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="printWidthProduct ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="printWidthProduct" placeholder="*{{localService.languageContent.barcode.total_width}}"
          title="*{{localService.languageContent.barcode.total_width}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.prize_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="priceFontSize ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="priceFontSize" placeholder="*{{localService.languageContent.barcode.prize_size}}"
          title="*{{localService.languageContent.barcode.prize_size}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.title_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="titleFontSize ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="titleFontSize" placeholder="*{{localService.languageContent.barcode.title_size}}"
          title="*{{localService.languageContent.barcode.title_size}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="text-align: right;">
        <button style="width:100%;" type="button" class="btn btn-primary"
          (click)="onPrintProduct()">{{localService.languageContent.barcode.print}}</button>
      </div>
    </div>
  </div>
  <div *ngIf="isBusiness && isShowMore && isShowLabelPrint" style="margin-bottom: 20px;">
    <div class="row">
      <div>
        <label>{{localService.languageContent.barcode.label}}</label>
      </div>
      <table style="width: calc(100% - 10px);" class="box">
        <tr>
          <td>
            <div [ngClass]="item.key" *ngFor="let item of titles" style="margin-top: 10px;text-align: center;">
              <span style="font-size:30px;">{{item.value}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="text-align: center;">
              <qrcode [qrdata]="barcodeValue" [width]="300" [errorCorrectionLevel]="'H'"></qrcode>
              <div *ngIf="displayValue != ''">
                {{displayValue}}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row">
      <div class="12">
        <div style="text-align: right;">
          <span>{{localService.languageContent.barcode.select_language}}</span>
        </div>
        <div *ngIf="languages">
          <ngx-select [items]="languages" [optionValueField]="'key'" [optionTextField]="'value'" [multiple]="true"
            placeholder="{{localService.languageContent.barcode.select_language}}" [(ngModel)]="selectedLanguages"
            [noAutoComplete]="true" (select)="onSelectLanguage()" (remove)="onSelectLanguage()">
          </ngx-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.bar_code_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSizeBusiness ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="barCodeSizeBusiness" placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
          title="*{{localService.languageContent.barcode.bar_code_size}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.total_width}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="printWidthBusiness ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="printWidthBusiness" placeholder="*{{localService.languageContent.barcode.total_width}}"
          title="*{{localService.languageContent.barcode.total_width}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.title_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="titleFontSizeBusiness ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="titleFontSizeBusiness" placeholder="*{{localService.languageContent.barcode.title_size}}"
          title="*{{localService.languageContent.barcode.title_size}}" (blur)="onSaveLastUsedSettingsForProduct()" />
      </div>
    </div>
    <div class="row">
      <div class="col-8" style="text-align: right;">
        <span>{{localService.languageContent.barcode.desc_size}}</span>
      </div>
      <div class="col-4">
        <input autocomplete="off" type="number" class="number" [ngClass]="descFontSizeBusiness ? 'en' : ''"
          style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
          [(ngModel)]="descFontSizeBusiness" placeholder="*{{localService.languageContent.barcode.desc_size}}"
          title="*{{localService.languageContent.barcode.desc_size}}" (blur)="onSaveLastUsedSettingsForBusiness()" />
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="text-align: right;">
        <button style="width:100%;" type="button" class="btn btn-primary"
          (click)="onPrintBusiness()">{{localService.languageContent.barcode.print}}</button>
      </div>
    </div>
  </div>
</div>
<div>
  <app-print-qrcode [(isOpenPopup)]="isOpenPopupPrintQr" [barcodeValue]="barcodeValue" [businessId]="businessId" [categoryCode]="categoryCode"></app-print-qrcode>
</div>